import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const uuid = require('uuid');

const Strings = require("../../../../../app/shared/Strings");
const ActivityStore = require('../../../stores/activity_store_reflux');
const ProjectStore = require('../../../stores/ProjectStore');
const ActivityActions = require('../../../actions/ActivityActions');
import Tooltip from '../../common/Tooltip';
import SortableTable2 from '../../table/SortableTable2';
import { TagNameInfo } from './OrgMetaTagInfoWarnings';

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tagRecord: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        tag: PropTypes.string.isRequired,
        display_order: PropTypes.number,
        user_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired,
    category: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        display_name: PropTypes.string.isRequired,
        requires_order: PropTypes.bool.isRequired,
        type: PropTypes.string, // TODO ...oneOf[Globals.X, Globals.Y]
    }),
    className: PropTypes.string,
    onDelete: PropTypes.func.isRequired,
    onReorder: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    maxDisplayOrder: PropTypes.number,
};

const defaultProps = {
    className: '',
    maxDisplayOrder: 0,
};

class OrgActMetaTagEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newTagName: null,
            newTagDisplayOrder: null,
            actsForTag: ActivityStore.getState().metaTagsToActivities[props.tagRecord.id] || [],
        };

        this.refreshActsForTag = this.refreshActsForTag.bind(this);
        this.onChangeTagName = this.onChangeTagName.bind(this);
        this.onChangeTagDisplayOrder = this.onChangeTagDisplayOrder.bind(this);
        this.onUpdateTagName = this.onUpdateTagName.bind(this)
        this.onUpdateTagDisplayOrder = this.onUpdateTagDisplayOrder.bind(this);
        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        this.refreshActsForTag(this.props.orgId, this.props.tagRecord.id);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tagRecord.id !== this.props.tagRecord.id) {
            this.setState({ newTagName: null, newTagDisplayOrder: null }, () => {
                this.refreshActsForTag(this.props.orgId, this.props.tagRecord.id);
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onActivityStoreChange(newState) {
        this.setState({
            actsForTag: newState.metaTagsToActivities[this.props.tagRecord.id] || [],
        });
    }

    refreshActsForTag(orgId, tagId) {
        ActivityActions.getActivitiesForMetaTag(
            uuid.v4(),
            {
                orgId: orgId,
                tagId: tagId,
            }
        );
    }

    onChangeTagName(e) {
        this.setState({ newTagName: e.target.value });
    }

    onChangeTagDisplayOrder(e) {
        this.setState({ newTagDisplayOrder: e.target.value });
    }

    onUpdateTagName() {
        if (!this.state.newTagName) return;
        this.props.onUpdate(this.state.newTagName);
    }

    onUpdateTagDisplayOrder() {
        const parsedDisplayOrder = parseInt(this.state.newTagDisplayOrder, 10);
        if (isNaN(parsedDisplayOrder)) return;
        this.props.onReorder(parsedDisplayOrder);
    }

    render() {
        const self = this;
        const tagNameToEdit = typeof this.state.newTagName === 'string' ? this.state.newTagName : this.props.tagRecord.tag;
        let tagDisplayOrderToEdit = typeof this.state.newTagDisplayOrder === 'string' ? this.state.newTagDisplayOrder : this.props.tagRecord.display_order;

        return (
            <div className={`${this.props.className}`}>
                <h3 className="large-heading-regular">
                    {Strings['en'].act_meta_tags.ACTIVITY_META_TAG}: <strong className="font-weight-bold">{this.props.tagRecord.tag}</strong>
                </h3>
                <hr className="medium hr-color-6" />
                <div className="margin-top-lg">
                    <h4>{Strings['en'].common.EDIT}</h4>
                    <hr className="small hr-color-6"/>
                    <Form className="padding-tb-md">
                        <Form.Group controlId={`new-tag-name-${this.props.tagRecord.id}`}>
                            <Form.Label>{Strings['en'].act_meta_tags.TAG_NAME}</Form.Label>
                            <Tooltip id={`org-at-tt-${this.props.tagRecord.id}`} className="margin-left-sm" placement="right">
                                <TagNameInfo />
                            </Tooltip>
                            <InputGroup>
                                <Form.Control
                                    value={tagNameToEdit}
                                    onChange={this.onChangeTagName}
                                />
                                <InputGroup.Append>
                                    <Button 
                                        disabled={!this.state.newTagName || tagNameToEdit === this.props.tagRecord.tag}
                                        onClick={this.onUpdateTagName}
                                    >
                                        {Strings['en'].common.UPDATE}
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </Form.Group>
                    </Form>
                    {(this.props.category.requires_order) &&
                        <Form className="padding-tb-md">
                            <Form.Group controlId={`new-tag-display-order-${this.props.tagRecord.id}`}>
                                <Form.Label>{Strings['en'].act_meta_tags.DISPLAY_ORDER} (0 - {this.props.maxDisplayOrder})</Form.Label>
                                <Tooltip id={`org-at-do-${this.props.tagRecord.id}`} className="margin-left-sm" placement="right">
                                    {Strings['en'].act_meta_tags.TAG_DISPLAY_ORDER_DESC}
                                </Tooltip>
                                <InputGroup>
                                    <Form.Control
                                        value={tagDisplayOrderToEdit}
                                        onChange={this.onChangeTagDisplayOrder}
                                        type="number"
                                    />
                                    <InputGroup.Append>
                                        <Button
                                            disabled={parseInt(tagDisplayOrderToEdit, 10) === this.props.tagRecord.display_order}
                                            onClick={this.onUpdateTagDisplayOrder}
                                        >
                                            {Strings['en'].common.UPDATE}
                                        </Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </Form.Group>
                        </Form>
                    }
                    <div className="padding-tb-md fl">
                        <Button variant="danger" onClick={this.props.onDelete}>
                            {Strings['en'].act_meta_tags.DELETE_TAG}
                        </Button>
                    </div>
                    <div className="padding-tb-md fr">
                        <Button onClick={this.props.onClose}>
                            {Strings['en'].common.STOP_EDITING}
                        </Button>
                    </div>
                    <div className="float-clear" />
                </div>
                <div className="margin-top-lg">
                    <h4>{Strings['en'].act_meta_tags.ACTS_W_ATTACHED}</h4>
                    <hr className="small hr-color-6"/>
                    {(this.state.actsForTag.length > 0) ?
                        <SortableTable2
                            classNameTable="font-size-md padding-tb-md"
                            hideSearch
                            showTotal={false}
                            uniqueRowKey="activity_id"
                            rowsPerPage={10}
                            rows={this.state.actsForTag}
                            dateFormat="YYYY-MM-DD HH:mm z"
                            defaultSort={{ key:'date_attached', type:'date', asc: false }}
                            columns={[
                                {
                                    displayName: Strings['en'].activity.ACTIVITY_NAME,
                                    key: 'activity_id',
                                    type: 'int',
                                    sortable: false,
                                },
                                {
                                    displayName: Strings['en'].project.PROJECT,
                                    key: 'project_id',
                                    type: 'int',
                                    sortable: false,
                                },
                                {
                                    displayName: Strings['en'].act_meta_tags.DATE_ATTACHED,
                                    key: 'date_attached',
                                    type: 'date',
                                }
                            ]}
                            displayColumnCallbacks={{
                                'activity_id': (actId) => {
                                    const actRecord = self.state.actsForTag.find(act => act.activity_id === actId);
                                    let activityName = `${Strings['en'].activity.ACTIVITY} ${actRecord.activity_id}`; // if for some reason the activity store doesn't have the act
                                    const actStoreState = ActivityStore.getStateActivity(actRecord.activity_id, actRecord.project_id, actRecord.channel_id);
                                    if (
                                        actStoreState.initialized
                                        && !!actStoreState.activity
                                    ) {
                                        activityName = actStoreState.activity.meta_data.title;
                                    }

                                    return (
                                        <Link
                                            to={`/project/${actRecord.channel_id}/${actRecord.project_id}/activity/${actRecord.activity_id}/meta_tags#category${self.props.category.id}`}
                                            target="_blank"
                                        >
                                            {activityName}
                                        </Link>
                                    );
                                },
                                'project_id': (projId) => {
                                    let projectName = `${Strings['en'].project.PROJECT} ${projId}`;
                                    const projectStoreState = ProjectStore.getStateProject(projId);
                                    if (
                                        projectStoreState.initialized
                                        && projectStoreState.project
                                    ) {
                                        projectName = projectStoreState.project.name;
                                    }

                                    return projectName;
                                }
                            }}
                        />
                        :
                        Strings['en'].common.NONE
                    }
                </div>
            </div>
        );
    }
}

OrgActMetaTagEditor.propTypes = propTypes;
OrgActMetaTagEditor.defaultProps = defaultProps;

export default OrgActMetaTagEditor;